import React, { useEffect, useState, useCallback, useContext } from "react";
import { Form, Typography, Checkbox } from "antd";
import CheckListFBYRadioItems from "../../../../../../blocks/FormItems/CheckListFBYRadioItems";
import { getInitialValuesForChild } from "../../../../../../helpers/getInitialValues";
import { noYesOptions } from "../../../../Options/commonOptions";
import {
  fractureAreasOptions,
  fractureTypeOptions,
} from "../../../../Options/systemicExamOptions";
import { DoctorInitialContext } from "../../../HistoryForm/DoctorHistoryFormProvider";
import DeselectableRadioGroup from "../../../../../../blocks/FormItems/DeselectableRadioGroup";
import DynamicInputFields from "../../../../../../blocks/FormItems/DynamicInputFields";

const { Text } = Typography;

const Fractures = ({ context, form }) => {
  const [refresh, setRefresh] = useState(false);
  const { formData } = useContext(context || DoctorInitialContext);
  const fractureData = formData?.systemic_examination || formData;
  const [fractureAreas, setFractureAreas] = useState({});
  const [checkboxes, setCheckboxes] = useState({});

  const toggleFractureArea = useCallback((value, e) => {
    setFractureAreas((prev) => ({
      ...prev,
      [value]: e.target.checked,
    }));
  }, []);

  const getFractureRightLeftOptions = useCallback(
    (area) => [
      { label: "Right-Closed", value: `${area}_right_closed` },
      { label: "Right-Open", value: `${area}_right_open` },
      { label: "Left-Closed", value: `${area}_left_closed` },
      { label: "Left-Open", value: `${area}_left_open` },
    ],
    []
  );

  useEffect(() => {
    if (formData?.systemic_examination?.fractures || formData?.fractures) {
      const fractures = fractureData?.fractures;

      setFractureAreas(
        fractureAreasOptions.reduce((acc, { value }) => {
          acc[value] = fractures[value] || false;
          return acc;
        }, {})
      );

      const initialCheckboxes = {};
      fractureAreasOptions.forEach(({ value }) => {
        const options = getFractureRightLeftOptions(value);
        const initialValues = getInitialValuesForChild(options, fractures);
        Object.assign(initialCheckboxes, initialValues);
      });
      setCheckboxes(initialCheckboxes);
    }
  }, [formData, getFractureRightLeftOptions]);

  const showOthers = ![false, undefined, null]?.includes(
    form.getFieldValue(["fractures", "others"])
  );

  return (
    <>
      <Text>Fractures</Text>
      <DeselectableRadioGroup
        name={["fractures", "status"]}
        options={noYesOptions}
        form={form}
        setRefresh={setRefresh}
      />
      {form.getFieldValue(["fractures", "status"]) === "yes" && (
        <div className="subsection-card">
          {fractureAreasOptions.map(({ label, value }) => (
            <div key={value}>
              <Form.Item
                shouldUpdate
                name={["fractures", value]}
                valuePropName="checked"
              >
                <Checkbox onChange={(e) => toggleFractureArea(value, e)}>
                  {label}
                </Checkbox>
              </Form.Item>
              {fractureAreas[value] && (
                <div className="subsection-card">
                  <CheckListFBYRadioItems
                    checkBoxOptions={getFractureRightLeftOptions(value)}
                    radioOptions={fractureTypeOptions}
                    checkboxes={checkboxes}
                    setCheckboxes={setCheckboxes}
                    form={form}
                    keyChain={"fractures"}
                  />
                </div>
              )}
            </div>
          ))}
          <Form.Item name={["fractures", "others"]} valuePropName="checked">
            <Checkbox onChange={() => setRefresh((prev) => !prev)}>
              Others
            </Checkbox>
          </Form.Item>
          {showOthers && (
            <DynamicInputFields
              field_key={["fractures", "others"]}
              form={form}
              inputStyle={{ maxWidth: 800 }}
            />
          )}
        </div>
      )}
    </>
  );
};

export default Fractures;
